import { useEffect, useState } from 'react'
import DateRangePicker from '@wojtekmaj/react-daterange-picker'
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import { Box, IconButton } from "@material-ui/core";
import 'react-calendar/dist/Calendar.css';
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import CancelIcon from '@material-ui/icons/Cancel';

interface DateRangeFilterProps {
  propertyName: string,
  updateFilter: any,
  reset: boolean
}

const DateRangeFilter = (dateRangeFilterProps: DateRangeFilterProps) => {
  useEffect(() => {
    if (dateRangeFilterProps.reset) {
      onChange([new Date(), new Date()]);
    }
  }, [dateRangeFilterProps.reset])

  type ValuePiece = Date | null;
  type Value = ValuePiece | [ValuePiece, ValuePiece];

  const [value, onChange] = useState<Value>(null);

  const handleChange = (dateRange: Value) => {
    onChange(dateRange);
    dateRangeFilterProps.updateFilter(getStringForFilter(dateRange));
  };

  const handleResetFilter = () => {
    if (value) {
      onChange(null);
      dateRangeFilterProps.updateFilter('');
    }
  }

  const getStringForFilter = (val: Value) => {
    if (Array.isArray(val) && val.length === 2) {
      let [startDate, endDate] = val;

      if (startDate?.getTime() === endDate?.getTime()) {
        endDate = moment(endDate).add(1, 'd').toDate();
      }
      return `${dateRangeFilterProps.propertyName}  ge  ${moment(startDate).toISOString()} and ${dateRangeFilterProps.propertyName} le  ${moment(endDate).toISOString()}`;
    }
  }

  const useStyles = makeStyles(() => ({
    dateRangePicker: {
      textAlign: "left",
      '& .react-daterange-picker__wrapper': {
        border: "none !important",
      },
      '& .react-daterange-picker__button': {
        display: "none",
      },
      '& .react-daterange-picker__calendar': {
        zIndex: 1200
      },
      '& .react-daterange-picker__inputGroup': {
        fontSize: '10px !important'
      }
    },
    box: {
      display: "flex",
      flexDirection: "row"
    }

  }));

  const classes = useStyles();

  return (
    <Box className={classes.box} px={1}>

      <DateRangePicker
        dayPlaceholder='dd'
        monthPlaceholder='mm'
        yearPlaceholder='yy'
        format={"y-MM-dd"}
        rangeDivider=''
        className={classes.dateRangePicker}
        calendarIcon
        locale='en-US'
        onChange={handleChange}
        clearIcon
        value={value} />
      <IconButton color="primary" aria-label="cancel" component="span" onClick={handleResetFilter} style={{ padding: 0 }}>
        <CancelIcon />
      </IconButton>
    </Box>
  );
};

export default DateRangeFilter;
